import { Request, Response, NextFunction } from 'express';
import { AuthRequest } from '../../middleware/auth.middleware';
import * as service from './channels.service';
import { getIo } from '../../realtime/socket.bootstrap';

export async function create(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const channel = await service.createChannel(req.params.teamId, req.user!.sub, req.body);
    getIo()?.emit("CHANNEL_CREATED", channel);
    res.status(201).json({ success: true, data: channel });
  } catch (err) { next(err); }
}

export async function list(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const channels = await service.listChannels(req.params.teamId, req.user!.sub);
    res.json({ success: true, data: channels });
  } catch (err) { next(err); }
}

export async function getOne(req: Request, res: Response, next: NextFunction) {
  try {
    const channel = await service.getChannel(req.params.id);
    res.json({ success: true, data: channel });
  } catch (err) { next(err); }
}

export async function archive(req: Request, res: Response, next: NextFunction) {
  try {
    await service.archiveChannel(req.params.id);
    getIo()?.emit("CHANNEL_DELETED", { channelId: req.params.id });
    res.json({ success: true });
  } catch (err) { next(err); }
}

export async function join(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    await service.joinChannel(req.params.id, req.user!.sub);
    res.json({ success: true });
  } catch (err) { next(err); }
}

export async function leave(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    await service.leaveChannel(req.params.id, req.user!.sub);
    res.json({ success: true });
  } catch (err) { next(err); }
}

export async function markRead(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    await service.markAsRead(req.params.id, req.user!.sub);
    res.json({ success: true });
  } catch (err) { next(err); }
}
